export const LABELS = {
	collectedByCourier_pre_delivery_dates: "Collected by courier",
	collectedByCourier: "סופק ללקוח",
	readyDateInfo: "לחיצה על הכפתור תעדכן את תאריך האספקה בפועל.",
	readyDateText: "תאריך אספקה מתוכנן",
	column_pickingAndScheduledDate: "Picking and Scheduled date",
	column_picking: "Picking",
	column_readyAndActualDate: "Ready and Actual date",
	column_ready: "Ready",
	slowInternetConnection: "החיבור לאינטרנט אינו יציב",
};
